import { Fetch, schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { fetch } from '../fetch';

export async function startTinkerBox(fetch: Fetch, id: number) {
    return fetch(
        `/tinker-boxes/${id}/start`,
        { method: 'POST' },
        schemas.SuccessDto
    );
}

export const useStartTinkerBoxMutation = () => {
    return useMutation({
        mutationKey: ['startTinkerBox'],
        mutationFn: (id: number) => startTinkerBox(fetch, id)
    });
};
